import type { ReferencePatent } from '../types';

/**
 * 空对象之参考专利信息
 */
export const EmptyReferencePatent: ReferencePatent = Object.create({});
